
// Helper function to format opening hours for schema
export const formatOpeningHours = (opening_hours: any) => {
  if (!opening_hours || typeof opening_hours !== 'object') return undefined;
  
  const dayMapping: { [key: string]: string } = {
    'lundi': 'Monday',
    'mardi': 'Tuesday', 
    'mercredi': 'Wednesday',
    'jeudi': 'Thursday',
    'vendredi': 'Friday',
    'samedi': 'Saturday',
    'dimanche': 'Sunday'
  };

  return Object.entries(opening_hours).map(([day, hours]) => {
    const dayName = dayMapping[day] || day;
    
    if (hours && typeof hours === 'object') {
      const hoursObj = hours as any;
      if (hoursObj.matin || hoursObj.apres_midi) {
        // Handle structured opening hours format
        const morningHours = hoursObj.matin;
        const afternoonHours = hoursObj.apres_midi;
        
        const specs = [];
        if (morningHours && morningHours !== 'Fermé') {
          const [opens, closes] = morningHours.split(' - ');
          if (opens && closes) {
            specs.push({
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": dayName,
              "opens": opens,
              "closes": closes
            });
          }
        }
        if (afternoonHours && afternoonHours !== 'Fermé') {
          const [opens, closes] = afternoonHours.split(' - ');
          if (opens && closes) {
            specs.push({
              "@type": "OpeningHoursSpecification", 
              "dayOfWeek": dayName,
              "opens": opens,
              "closes": closes
            });
          }
        }
        return specs;
      }
    }
    return [];
  }).flat().filter(spec => spec["@type"]);
};
